import { getMessage } from '@tcc/i18n';
import { PlantingEventsResponse, PlantingEvents, PlantingProducts } from '../../types/Planting';
import { LOCALE_GROUPS, POPULATION_WEIGHT_UNITS } from '../../constants/units';

const DoesProductExist = (existingProductList: PlantingProducts, currentProduct: { id: string, date: string }) => existingProductList.find(product => product?.id === currentProduct?.id && product?.date === currentProduct?.date);

export const parsePlantingData = (data: PlantingEventsResponse[]): PlantingEvents => {
  if (!data || !data.length) {
    return {
      events: {},
      plantingSeasons: [],
    }
  }
  return data.reduce((acc, curr) => {
    const { seasonCode, averageSeedPopulation, totalPlantedArea, seedProduct, plantingDate } = curr;

    if (!acc.events[seasonCode]) {
      acc.events[seasonCode] = {
        date: plantingDate,
        seedProducts: [],
        area: {
          q: 0,
          u: ''
        },
        population: {
          q: 0,
          u: '',
          localeGroup: LOCALE_GROUPS.POPULATION_WEIGHT
        }
      };
      acc.plantingSeasons.push({ season: seasonCode });
    }

    const seasonData = acc.events[seasonCode];

    // Update total planted area
    seasonData.area.q += totalPlantedArea.v;
    seasonData.area.u = totalPlantedArea.u;

    // Update total average seed population
    const paT = seasonData.area.q;
    const spT = (seasonData.population.q * (paT - totalPlantedArea.v) + averageSeedPopulation.v * totalPlantedArea.v) / paT;

    seasonData.population.q = spT;
    seasonData.population.u = averageSeedPopulation.u;

    seasonData.date = new Date(plantingDate) >= new Date(seasonData.date as string) ? plantingDate : seasonData.date;
    seasonData.population.localeGroup = seasonData.population.u === POPULATION_WEIGHT_UNITS.PLANTING_ABBREVIATED
      ? LOCALE_GROUPS.POPULATION_WEIGHT
      : LOCALE_GROUPS.POPULATION


    // Update seed products
    const productId = seedProduct ? seedProduct.id : 'unknown';
    const productName = seedProduct ? seedProduct.name : getMessage('legend.unknown');
    const existingProduct = DoesProductExist(seasonData.seedProducts, { id: productId, date: plantingDate });

    if (existingProduct) {
      existingProduct.plantedArea += totalPlantedArea.v;
    } else {
      seasonData.seedProducts.push({
        id: productId,
        name: productName ?? '',
        plantedArea: totalPlantedArea.v,
        unit: totalPlantedArea.u,
        date: plantingDate,
      });
    }

    return acc;
  }, {
    events: {},
    plantingSeasons: [],
  } as PlantingEvents)
};
